import { SharedModule } from './../shared/shared.module';
import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AccountComponent } from './account/account.component';
import { AccountDetailsComponent } from './account-details/account-details.component';
import { AccountAddressComponent } from './account-address/account-address.component';
import { AccountWishlistComponent } from './account-wishlist/account-wishlist.component';
import { AccountOrdersComponent } from './account-orders/account-orders.component';
import { EditAddressComponent } from './edit-address/edit-address.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import { OrderDetailComponent } from './order-detail/order-detail.component';
import { OffersComponent } from './offers/offers.component';
import { EventHistoryComponent } from './event-history/event-history.component';
import { AuthGuardService } from '../guards/auth-guard.service';



@NgModule({
  declarations: [EditAddressComponent,
    AccountComponent,
     AccountDetailsComponent,
     AccountAddressComponent,
     AccountWishlistComponent,
     AccountOrdersComponent,
     EditAddressComponent,
     OrderDetailComponent,
     OffersComponent,
     EventHistoryComponent],
  imports: [
    CommonModule,
    FormsModule,
    NgbModule,
    SharedModule,
    RouterModule.forRoot([
      
      { path: 'order-detail/:id', component: OrderDetailComponent,canActivate: [AuthGuardService]},
      { path: 'edit-address/:id', component: EditAddressComponent,canActivate: [AuthGuardService]},
      { path: 'add-address', component: EditAddressComponent,canActivate: [AuthGuardService]},
      {path: 'account' , component: AccountComponent, children: [
        {path: '', redirectTo: 'details', pathMatch: 'full'},
        {path: 'address', component: AccountAddressComponent,canActivate: [AuthGuardService]},
        {path: 'orders', component: AccountOrdersComponent,canActivate: [AuthGuardService]},
        {path: 'wishlist', component: AccountWishlistComponent,canActivate: [AuthGuardService]},
        {path: 'details', component: AccountDetailsComponent,canActivate: [AuthGuardService]},
        {path: 'event-history', component: EventHistoryComponent,canActivate: [AuthGuardService]},
        {path: 'offers', component: OffersComponent},
        {path: '**', redirectTo: 'details', pathMatch: 'full'}
      ] }
    ])
  ]
})
export class AccountModule { }
